import { ApolloError, useQuery } from '@apollo/client'
import { CompanyManagerDashboardListOfCompaniesQuery, CompanyManagerDashboardListOfCompaniesQueryVariables } from '../../types'
import { COMPANY_MANAGER_DASHBOARD_LIST_OF_COMPANIES } from './Queries'

export const useCompanyManagerDashboardListOfCompanies = (): {
  data: CompanyManagerDashboardListOfCompaniesQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const { data, error, loading } = useQuery<
    CompanyManagerDashboardListOfCompaniesQuery,
    CompanyManagerDashboardListOfCompaniesQueryVariables
  >(COMPANY_MANAGER_DASHBOARD_LIST_OF_COMPANIES)

  return { data, error, loading }
}
